import { RubyObject } from "./default";
import { FilterParams } from "./filterParams";

export enum CampaignType {
  Video = "Video",
  Document = "Document",
}

export interface Campaign extends RubyObject {
  assigned: boolean;
  campaign_type: CampaignType;
  data: Record<string, unknown>;
  // data should like the below but is a JSONB column so Record is safer
  // {
  //   proximity?: number;
  //   searchTerms: string[];
  //   filterParams: FilterParams;
  //   mustIncludeTerms?: string[];
  // };
  name: string;
  organization_id: number;
  user_id: number;
}

export interface CampaignData {
  filterParams: FilterParams;
  mustIncludeTerms?: string[];
  proximity?: number;
  searchTerms: string[];
}

export enum EmailCadence {
  Unsubscribed = "Unsubscribed",
  Daily = "Daily",
  Weekly = "Weekly",
}
